
import 'react-circular-progressbar/dist/styles.css';
import { QR_MAKER } from '../../constant/constant';
import { useSelector } from 'react-redux';
import './QRComponent.css';

const QRComponent = ({amount}) => {
    const userState = useSelector((state:any)=> state.user);
    const { email = '', userName = '' } = userState?.user || {};
    const qrContent = userName || email.split('@')[0];
    const qrUrl = getQRCodeURL(amount,qrContent);
    return (
        <img src={qrUrl} alt="" />
      );
};

const getQRCodeURL = (amount,name) => {
    const param = `amount=${amount}&addInfo=${name}&accountName=1ClickFaceSwap`;
    return `${QR_MAKER}?${param}`;
}
export default QRComponent;